import { Middleware } from '@reduxjs/toolkit';
import { syncAuthCookieWithRedux } from '~/utils/authBridge';
import { 
  loginSuccess, 
  googleLoginSuccess, 
  logOutSuccess,
  fetchCurrentUserSuccess 
} from '../slices/user';

/**
 * Middleware to sync authentication state with cookies for cross-domain sharing
 */
export const authCookieMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);
  
  // Sync cookie when authentication state changes
  if (
    loginSuccess.match(action) ||
    googleLoginSuccess.match(action) ||
    logOutSuccess.match(action) ||
    fetchCurrentUserSuccess.match(action)
  ) {
    const state = store.getState();
    syncAuthCookieWithRedux(state.user);
  }
  
  return result;
};
